import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pui-row',
  templateUrl: 'row.component.html'
})
export class PuiRowComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
